import { IMedicalSummaryForm } from "@/app/components/routes/auth_routes/OrderManagement/interface";
import RadioGroupComponent from "@/app/components/ui/RadioGroup";
import { UseFormReturn } from "react-hook-form";

interface IClinicalNotesSectionProps {
  sectionOuterClass: string;
  medicalSummaryForm: UseFormReturn<IMedicalSummaryForm>;
  onQueueAutoSave: () => void;
}

const ClinicalNotesSection = ({ sectionOuterClass, medicalSummaryForm, onQueueAutoSave }: IClinicalNotesSectionProps) => {
  return (
    <div className={sectionOuterClass}>
      <div className="mt-2 rounded-xl bg-white px-2 py-3">
        <div data-autosave-section="concern_and_symptoms">
          <p className="text-sm text-[#656565]">
            Concern & Symptoms <span className="text-[#ED0101]">*</span>
          </p>
          <input
            type="text"
            className="mt-2 h-9 w-full rounded-md border border-[#E2E2E2] bg-white px-3 text-sm text-[#1F1F23] placeholder:text-gray-400 focus:border-[#E2E2E2] focus:outline-none focus:ring-1 focus:ring-[#E2E2E2]"
            placeholder="Write if anything requires..."
            {...medicalSummaryForm.register("concern_and_symptoms", { required: true })}
          />
        </div>

        <div className="mt-5" data-autosave-section="ongoing_medication">
          <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:gap-3">
            <label className="mb-0 min-w-[150px] text-sm text-[#656565]">
              Ongoing Medication <span className="text-[#ED0101]">*</span>
            </label>
            <RadioGroupComponent
              alignment="horizontal"
              errorMessages={[]}
              fieldError={medicalSummaryForm.formState.errors.ongoing_medication}
              register={medicalSummaryForm.register("ongoing_medication", { required: true })}
              groupOptions={[
                { id: "Yes", title: "Yes", colorClassName: "text-green-500" },
                { id: "No", title: "No", colorClassName: "text-red-500" },
              ]}
              defaultSelectedId={medicalSummaryForm.watch("ongoing_medication")}
              onRadioChange={(optionId: string) => {
                medicalSummaryForm.setValue("ongoing_medication", optionId, { shouldValidate: true });
                onQueueAutoSave();
              }}
              radioOptionClassName="text-sm w-20"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClinicalNotesSection;
